<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-title">Criar Plano de Ação</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="nameInput">Pesquisa</label>
                                    <select class="form-control" v-model="actionPlan.research_id">
                                        <option
                                            v-for="research in researches"
                                            :key="research.id"
                                            :value="research.id"
                                        >{{ research.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="nameInput">Tarefa/Atividade (o que será feito)</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="actionPlan.name"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="actionStartInput">Início</label>
                                    <date-picker
                                        v-model="actionPlan.start_date"
                                        :output-format="'YYYY-MM-DD HH:mm'"
                                        :format="'YYYY-MM-DD HH:mm'"
                                        :formated="'YYYY-MM-DD HH:mm'"
                                        :button-now-translation="'Hoje'"
                                        :label="'Data'"
                                    ></date-picker>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="actionEndInput">Término</label>
                                    <date-picker
                                        v-model="actionPlan.end_date"
                                        :output-format="'YYYY-MM-DD HH:mm'"
                                        :format="'YYYY-MM-DD HH:mm'"
                                        :formated="'YYYY-MM-DD HH:mm'"
                                        :button-now-translation="'Hoje'"
                                        :label="'Data'"
                                    ></date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Responsável</label>
                                    <select
                                        v-model="actionPlan.responsible_id"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="user in users"
                                            :key="user.id"
                                            :value="user.id"
                                        >{{ user.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="placeInput">Local</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="actionPlan.place"
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Dimensão</label>
                                    <select
                                        v-model="actionPlan.dimension_id"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="dimension in dimensions"
                                            :key="dimension.id"
                                            :value="dimension.id"
                                        >{{ dimension.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="costInput">Custo previsto</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model.lazy="actionPlan.cost"
                                        v-money="money"
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="typeInput">Tipo</label>
                                    <select v-model="actionPlan.type_id" class="form-control">
                                        <option
                                            v-for="type in actionPlanTypes"
                                            :key="type.id"
                                            :value="type.id"
                                        >{{ type.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="priorInput">Prioridade</label>
                                    <select v-model="actionPlan.priority_id" class="form-control">
                                        <option
                                            v-for="priority in actionPlanPriorities"
                                            :key="priority.id"
                                            :value="priority.id"
                                        >{{ priority.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="howText">Como?</label>
                                    <textarea
                                        class="form-control"
                                        v-model="actionPlan.description"
                                        rows="3"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="whyText">Por quê?</label>
                                    <textarea
                                        class="form-control"
                                        v-model="actionPlan.reason"
                                        rows="3"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div v-if="actionPlan.answer">
                            <hr />
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>O que foi feito?</label>
                                        <textarea
                                            class="form-control"
                                            :value="actionPlan.answer.description"
                                            rows="3"
                                            readonly
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 centered">
                                    <div class="card" style="width: 18rem;">
                                        <div class="card-body">
                                            <h5 class="card-title mb-4">Anexo</h5>
                                            <i class="fas fa-file fa-3x mb-4"></i>
                                            <p class='mt-2 centered'>{{ getFileName(actionPlan.answer.file) }}</p>
                                        </div>
                                        <ul class="list-group list-group-flush">
                                            <a
                                                :href="actionPlan.answer.file_http"
                                                targer="_blank"
                                                class="btn btn-normal-slim mt-3"
                                            >
                                                <i class="fas fa-download"></i>
                                                <br />
                                            </a>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="actionPlan.id">
                                <div
                                    class="col-md-12 text-right"
                                >Data e hora da criação do Plano de Ação: {{ formatDateTime(actionPlan.created_at) }}</div>
                            </div>
                            <div class="row" v-if="actionPlan.answer.id">
                                <div
                                    class="col-md-12 text-right"
                                >Data e hora da resposta do Plano de Ação: {{ formatDateTime(actionPlan.answer.created_at) }}</div>
                            </div>
                        </div>
                        <!-- Save -->
                        <div class="row justify-content-end mt-4">
                            <div class="col-md-6">
                                <button class="btn btn-next btn-block" @click="save">
                                    Salvar
                                    <i class="fas fa-save"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            actionPlan: {
                name: "",
                place: "",
                start_date: "",
                end_date: "",
                cost: "",
                description: "",
                reason: "",
                responsible_id: "",
                priority_id: "",
                type_id: "",
                research_id: "",
                dimension_id: ""
            },
            users: [],
            researches: [],
            actionPlanTypes: [],
            dimensions: [],
            actionPlanPriorities: [],
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "R$ ",
                suffix: "",
                precision: 2,
                masked: false
            },
            actionPlanAnswer: {}
        };
    },
    computed: {},
    methods: {
        getFileName(path){
            if(!path){
                return path;
            }
            let pathArray = path.split('/')
            if(pathArray.length > 0){
                return pathArray[pathArray.length - 1]
            } else {
                return path
            }
        },
        formatDateTime(dateTime) {
            return moment(dateTime).format("DD/MM/YYYY HH:mm:ss");
        },
        makeFormData() {
            const fd = new FormData();

            fd.append("name", this.actionPlan.name);
            fd.append("place", this.actionPlan.place);
            fd.append("start_date", this.actionPlan.start_date);
            fd.append("end_date", this.actionPlan.end_date);
            fd.append(
                "cost",
                this.actionPlan.cost
                    .split("R$ ")
                    .join("")
                    .split(".")
                    .join("")
                    .split(",")
                    .join(".")
            );
            fd.append("description", this.actionPlan.description);
            fd.append("reason", this.actionPlan.reason);
            fd.append("responsible_id", this.actionPlan.responsible_id);
            fd.append("dimension_id", this.actionPlan.dimension_id);
            fd.append("priority_id", this.actionPlan.priority_id);
            fd.append("type_id", this.actionPlan.type_id);
            fd.append("research_id", this.actionPlan.research_id);

            if (this.actionPlan.id) {
                fd.append("_method", "PUT");
            }

            return fd;
        },
        save() {
            const self = this;
            let api = self.$store.state.api + "actionplans";

            if (self.actionPlan.id) {
                api += "/" + self.actionPlan.id;
            }

            const fd = self.makeFormData();

            self.$http
                .post(api, fd)
                .then(response => {
                    self.$message(
                        "Sucesso",
                        "Plano de ação salvo com sucesso",
                        "success"
                    );
                    self.$router.push("/actionPlans");
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getDimensions() {
            const self = this;
            const api = self.$store.state.api + "dimensions?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.dimensions = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getUsers() {
            const self = this;
            const api = self.$store.state.api + "users?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.users = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getActionPlanTypes() {
            const self = this;
            const api =
                self.$store.state.api + "actionplantypes?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.actionPlanTypes = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getActionPlanPriorities() {
            const self = this;
            const api =
                self.$store.state.api + "actionplanpriorities?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.actionPlanPriorities = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getActionPlan(id) {
            const self = this;
            const api = self.$store.state.api + "actionplans/" + id;
            self.$http
                .get(api, {
                    params: {
                        with: ["answer", "research"]
                    }
                })
                .then(response => {
                    response.data.data[0].cost = response.data.data[0].cost.toFixed(2);
                    self.actionPlan = response.data.data[0];
                    self.researches = [response.data.data[0].research];
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getResearches(id) {
            const self = this;
            const api =
                self.$store.state.api +
                "researches?status_id=8&paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.researches = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        }
    },
    mounted: function() {
        this.getUsers();
        this.getDimensions();
        this.getActionPlanTypes();
        this.getActionPlanPriorities();
        this.getResearches();

        if (this.$route.params.id) [this.getActionPlan(this.$route.params.id)];
    }
};
</script>


// WEBPACK FOOTER //
// src/components/ActionPlan/ActionPlan.vue